import { fromSpecific } from '@rehaje/core'
import { reactive } from '@rehaje/reactive'

import { ValuableNode } from '../../models/ValuableNode'

export class SchemaNumberNode extends ValuableNode {
  @fromSpecific()
  @reactive()
  maximum?: number

  @fromSpecific()
  @reactive()
  minimum?: number
}

declare global {
  export interface RehajeTypedNodes {
    'Schema.Number': SchemaNumberNode
  }
}
